import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import EditComplain from "./editComplain";
import { documentUploadUrl } from "services/redux/fileUpload/action";
import {
  raiseComplain, getComplains, viewDetails
} from "services/redux/fileComplain/action"

const mapStateToProps = (state) => ({
  // formDropdowns: state.fileComplainReducer.formDropdowns,
  fileComplainRaised: state.fileComplainReducer.fileComplainRaised,
  viewComplainDetails: state.fileComplainReducer.viewComplain
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    // getFormDropdowns,
    documentUploadUrl,
    raiseComplain,
    getComplains,
    viewDetails,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EditComplain);
